// extracted by mini-css-extract-plugin
module.exports = {"button":"XlsxDownLoadButton_button__3LTYm","isLoading":"XlsxDownLoadButton_isLoading__3Cn9x"};